import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canUsePermissionDebug } from '../utils/permissionDebug'
import { defaultHomePath } from '../utils/gestionCampanaAccess'

const RequirePermissionDebugAccess = ({ children }) => {
  const { user, realUser } = useUser()

  if (!canUsePermissionDebug(realUser || user)) {
    return <Navigate to={defaultHomePath(realUser || user)} replace />
  }

  return children
}

export default RequirePermissionDebugAccess
